import { Checkbox, Field, Select } from '../../components/ui';
import { t } from '../../i18n';
import { buildRule, describeRule, type Frequency, type RecurrenceForm, type Weekday, WEEKDAYS } from './data';

const FREQUENCIES: readonly Frequency[] = ['none', 'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];

/** Repetición de una tarea: cada cuánto y, si es semanal, qué días. Muestra la regla en palabras. */
export function RecurrenceEditor({ value, onChange, idPrefix }: { value: RecurrenceForm; onChange: (v: RecurrenceForm) => void; idPrefix: string }) {
  const summary = describeRule(buildRule(value));
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium text-slate-700">{t('ta.repetir')}</legend>
      <div className="grid grid-cols-2 gap-3">
        <Select id={`${idPrefix}-frecuencia`} label={t('ta.frecuencia')} value={value.freq} onChange={(e) => onChange({ ...value, freq: e.target.value as Frequency })}>
          {FREQUENCIES.map((f) => (
            <option key={f} value={f}>
              {t(`ta.frecuencia_${f}` as 'ta.frecuencia_none')}
            </option>
          ))}
        </Select>
        {value.freq !== 'none' && (
          <Field
            id={`${idPrefix}-intervalo`}
            type="number"
            min="1"
            max="366"
            label={t('ta.intervalo')}
            value={String(value.interval)}
            onChange={(e) => onChange({ ...value, interval: Math.max(1, Math.min(366, Number(e.target.value) || 1)) })}
          />
        )}
      </div>
      {value.freq === 'WEEKLY' && (
        <div className="flex flex-wrap gap-3" role="group" aria-label={t('ta.dias_semana')}>
          {WEEKDAYS.map((d: Weekday) => (
            <Checkbox key={d} label={t(`ta.dia_corto_${d}` as 'ta.dia_corto_MO')} checked={value.days.includes(d)} onChange={(e) => onChange({ ...value, days: e.target.checked ? [...value.days, d] : value.days.filter((x) => x !== d) })} />
          ))}
        </div>
      )}
      {summary && <p className="text-xs text-slate-500">{t('ta.se_repite', { regla: summary })}. {t('ta.repetir_ayuda')}</p>}
    </fieldset>
  );
}
